import { render, staticRenderFns } from "./excel-uploading.vue?vue&type=template&id=060d5470&"
import script from "./excel-uploading.vue?vue&type=script&lang=js&"
export * from "./excel-uploading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports